import type {
  CompanyUsersResponse,
  InviteUserPayload,
  UpdateUserPayload,
  UserDetail,
} from '@/api/users/types';
import { API_ROOT_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';

export async function fetchCompanyUsers(
  qs: string,
): Promise<CompanyUsersResponse> {
  return apiFetch<CompanyUsersResponse>(`/api/users?${qs}`, {}, API_ROOT_URL);
}

export async function createUser(
  payload: InviteUserPayload,
): Promise<{ id: string }> {
  return apiFetch<{ id: string }>(
    '/api/users',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
    API_ROOT_URL,
  );
}

/** One colleague's profile. Guarded by `user:read` on the server. */
export async function fetchUser(id: string): Promise<UserDetail> {
  return apiFetch<UserDetail>(`/api/users/${id}`, {}, API_ROOT_URL);
}

/** Guarded by `user:edit`. Returns the updated record. */
export async function updateUser(
  id: string,
  payload: UpdateUserPayload,
): Promise<UserDetail> {
  return apiFetch<UserDetail>(
    `/api/users/${id}`,
    { method: 'PUT', body: JSON.stringify(payload) },
    API_ROOT_URL,
  );
}
